import React, { useEffect, useState } from 'react';
import { Card, Spinner, Badge, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getTopResponseHours } from 'services/surveys';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

const TopResponseHours = ({ surveyId, className = '' }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!surveyId || surveyId === 0) {
        setData([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await getTopResponseHours(surveyId);
        console.log('Top Response Hours:', response);

        if (response) {
          setData(response);
        } else {
          setData([]);
          setError('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error al obtener top de horarios:', err);
        setError('Error al cargar los datos');
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [surveyId]);

  if (loading) {
    return (
      <Card className={className}>
        <FalconCardHeader
          title="⏰ Top 5 Horarios con Más Respuestas"
          light={false}
          titleTag="h5"
          className="pb-0"
        />
        <Card.Body className="text-center py-4">
          <Spinner animation="border" size="sm" className="me-2" />
          <span className="text-muted">Cargando horarios...</span>
        </Card.Body>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className={className}>
        <FalconCardHeader
          title="⏰ Top 5 Horarios con Más Respuestas"
          light={false}
          titleTag="h5"
          className="pb-0"
        />
        <Card.Body className="text-center py-4 text-muted">
          <FontAwesomeIcon icon={faClock} className="me-2" />
          {error}
        </Card.Body>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card className={className}>
        <FalconCardHeader
          title="⏰ Top 5 Horarios con Más Respuestas"
          light={false}
          titleTag="h5"
          className="pb-0"
        />
        <Card.Body className="text-center py-4 text-muted">
          <FontAwesomeIcon icon={faClock} className="me-2" />
          No hay datos de horarios disponibles
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <FalconCardHeader
        title="⏰ Top 5 Horarios con Más Respuestas"
        light={false}
        titleTag="h5"
        className="pb-0"
      />
      <Card.Body className="pt-2">
        <Row className="g-2">
          {data.map((item, index) => (
            <Col xs={12} md={6} lg={4} key={item.hour}>
              <div className="d-flex align-items-center p-3 bg-light rounded">
                <Badge
                  bg={
                    index === 0
                      ? 'primary'
                      : index === 1
                      ? 'success'
                      : index === 2
                      ? 'warning'
                      : 'secondary'
                  }
                  className="me-3 px-2 py-1"
                >
                  #{index + 1}
                </Badge>
                <div>
                  <div className="fw-bold text-dark">
                    <FontAwesomeIcon
                      icon={faClock}
                      className="me-2 text-primary"
                    />
                    {item.hour_formatted}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

TopResponseHours.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  className: PropTypes.string
};

export default TopResponseHours;
